"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scheduling = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../ProviderTabs.styles");
// TODO Add real content https://kyruus.jira.com/browse/KENG-30548
const Scheduling = (_) => {
    return react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "scheduling" }, "Scheduling Will Go Here");
};
exports.Scheduling = Scheduling;
//# sourceMappingURL=Scheduling.js.map